import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2DocumentType } from '@/api/model/interfaces';

export default class PackageKS2DocumentTypeOdata extends OdataManager<PackageKS2DocumentType> {}
